import React from "react";
import { useSelector } from "react-redux";

import { Container, Title, InfoTitle, InfoData, ImageContainer, ImageBackground } from "./styles";

//Assets
import logo from "../../assets/img/logo.svg";

//Interfaces
import { EstablishmentBoxPropsInterface } from "./interfaces";

const EstablishmentBox = (props: EstablishmentBoxPropsInterface) => {
    const login = useSelector((state: {login: any}) => state.login);

    const getBranchInfo = () => {
        if(props.selectedBranch.ownersId !== undefined){
            return {
                businessName: login.user.owners.businessName,
                document: login.user.owners.taxpayerId,
                email: login.user.owners.businessEmail,
                phoneNumber: login.user.owners.businessPhone
            }
        } else {
            return {
                businessName: props.selectedBranch.businessDescription,
                document: props.selectedBranch.taxpayerIdBranch,
                email: props.selectedBranch.businessEmail,
                phoneNumber: props.selectedBranch.businessPhone
            }
        }
    }

    const establishment = getBranchInfo()

    return(
        <Container tooltip={props.tooltip} selectedBranch={""}>
            <Title>Estabelecimento</Title>
            
            <div className="d-flex justify-content-between">
                <div style={{maxWidth: 150}}>
                    <InfoTitle>Nome</InfoTitle>
                    <InfoData>{establishment.businessName}</InfoData>
                    <InfoTitle>CNPJ</InfoTitle>
                    <InfoData>{establishment.document}</InfoData>
                    <InfoTitle>E-mail</InfoTitle>
                    <InfoData>{establishment.email}</InfoData>
                    <InfoTitle>Telefone</InfoTitle>
                    <InfoData>{establishment.phoneNumber}</InfoData>
                </div>
            </div>
            
        </Container>
    )
}

export default EstablishmentBox;